import React, { useEffect } from "react";
import MiniGamePageHome from "../Home";
import { getDataApi, postDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { TYPE_GIVE_MINIGAME, TYPE_GIVE_PIECE } from "../../../../helper/const";
import { useDispatch } from "@pages/Events/MiniGame/store";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../Redux/futures/mini-game/action";
import { useParams } from "react-router-dom";

export default function ComponentGive() {
  const dispatch = useDispatch();
  const { awardId: id } = useParams();

  const handleGetLink = async () => {
    const dataGetLink = await getDataApi(
      `${API_PATH.miniGameGetCodePieceLinkInfo}?code=${id}&type=${TYPE_GIVE_MINIGAME.give}`
    );

    if (!dataGetLink?.data || !dataGetLink?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataGetLink?.message || "",
        })
      );
    }
    // thành công
    dataGetLink.typeWeb = TYPE_GIVE_MINIGAME.give;
    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        type: TYPE_GIVE_PIECE.accept,
        link: id,
        data: dataGetLink,
      })
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const giveId = searchParams.get("giveId");
    if (!giveId) {
      return null;
    }

    handleGetLink();
  }, []);
  return <MiniGamePageHome />;
}
